import type { Club } from "./api";

/**
 * Whether the club has a standing weekly slot.
 *
 * Both halves are required: a day without a time (or the reverse) is not
 * something the site can honestly display, so it is treated as unset.
 */
export function hasWeeklyMeeting(club: Club | null): boolean {
  return Boolean(club?.meeting.weekday_name && club?.meeting.start_time);
}

/** The club's primary link, used to point people somewhere when nothing is scheduled. */
export function primaryLink(club: Club | null) {
  return club?.links.find((link) => link.primary) ?? club?.links[0] ?? null;
}
